import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useState, useEffect } from "react";
import { GlobalProvider } from "./GlobalContext";
import MainLayout from "./Components/MainLayout";
import SettingsPage from "./Components/Settings/SettingsPage";
import TeamsPage from "./Components/Teams/TeamsPage";
import DriversPage from "./Components/Driver/DriversPage";
import BankPage from "./Components/Banks/BankPage";
import TasksPage from "./Components/Tasks/TasksPage";
import ReportsPage from "./Components/Reports/ReportsPage";
import LoginPage from "./Components/Login/LoginPage";
import ShopsPage from "./Components/Shops/ShopsPage";
import LogoutWatcher from "./Components/Utils/LogoutWatcher";
import { Toaster } from "react-hot-toast";
import "./App.css";
import SlotManager from "./Components/Gigs/SlotManager";
import TierSection from "./Components/Tier/Tier";
import Notification from "./Components/Notification/Notification";
import IntroScreen from "../src/Components/Utils/IntroScreen"; 
import DashboardContainer from "./Components/MainDashboard/DashboardContainer";
import Attendance from "./Components/Attendance/Attendance";

function App() {

   const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return sessionStorage.getItem("admin") !== null;
  });

  // State to manage intro screen
  const [audioUnlocked, setAudioUnlocked] = useState(false);
  
  useEffect(() => {
    // If already unlocked previously, skip intro
    if (localStorage.getItem("audioUnlocked") === "true") {
      setAudioUnlocked(true);
    }
  }, []);

   useEffect(() => {
    const checkAuth = () => {
      setIsAuthenticated(sessionStorage.getItem("admin") !== null);
    };

    window.addEventListener("storage", checkAuth);
    const interval = setInterval(checkAuth, 100);

    return () => {
      window.removeEventListener("storage", checkAuth);
      clearInterval(interval);
    };
  }, []);

  return (
    <Router>
      <GlobalProvider>
        {/* Intro Screen Overlay */}
        {!audioUnlocked && (
          <IntroScreen onContinue={() => setAudioUnlocked(true)} />
        )}

        <Toaster position="top-center" toastOptions={{ duration: 5000 }} />

        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {isAuthenticated ? (
            <Route path="/" element={<MainLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route
                path="dashboard"
                element={
                  <>
                    <LogoutWatcher />
                    <DashboardContainer />
                  </>
                }
              />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="teams" element={<TeamsPage />} />
              <Route path="driver" element={<DriversPage />} />
              <Route path="banks" element={<BankPage />} />
              <Route path="tasks" element={<TasksPage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="shops" element={<ShopsPage />} />
              <Route path="slots" element={<SlotManager />} />
              <Route path="tiers" element={<TierSection />} />
              <Route path="notifications" element={<Notification />} />
               <Route path="attendance" element={<Attendance />} />
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/login" replace />} />
          )}
        </Routes>
      </GlobalProvider>
    </Router>
  );
}

export default App;
